import { render, staticRenderFns } from "./provinceAndCity.vue?vue&type=template&id=b5acb77c&scoped=true&"
import script from "./provinceAndCity.vue?vue&type=script&lang=js&"
export * from "./provinceAndCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5acb77c",
  null
  
)

export default component.exports